module.exports = __webpack_public_path__ + "img/1824.511a2ebb.gif";